import { useLocale } from '@/common/hooks/index';
import { formatDisplayDate } from '@/common/utils/index';

const DateCell = ({ value }) => {
  const { isFr } = useLocale();

  if (!value) return '-';

  return formatDisplayDate(value, isFr ? 'fr' : 'en');
};

export const renderDateCell = ({ value }) => <DateCell value={value} />;
